<template>
  <div id="unDispatchList">
        <i class="el-icon-refresh" style="position: absolute;right:40px;top:20px;font-size: 25px;cursor: pointer;" @click="refresh()"></i>
        <el-col class="fl searthPart" style="width: 100%;">
            <el-form :inline="true" ref="searchForm" :model="searchForm" :label-position="labelPosition">
                <el-form-item style="width:100px">
                    <el-select filterable @change="selectCity" v-model="searchForm.city" placeholder="城市" clearable>
                        <el-option v-for="(item,index) in pickingCityList" 
                            :label="item.name" 
                            :value="item.id" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isSh" style="width:100px">
                    <el-select filterable v-model="searchForm.countyType" placeholder="区域" clearable>
                        <el-option v-for="(item,index) in pickingAreaList" 
                            :label="item.paraName" 
                            :value="item.paraCode" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-select clearable filterable v-model="searchForm.serviceType" placeholder="订单类型" style="width:120px">
                    <el-option v-for="(item,index) in orderTypeList" 
                        :key="index" 
                        :label="item.paraName" 
                        :value="item.paraValue">
                    </el-option>
                </el-select>
                <el-select clearable filterable v-model="searchForm.orderIdentifier" placeholder="渠道" style="width:120px;">
                    <el-option v-for="(item,index) in OrderNolList" 
                        :key="index" 
                        :label="item.paraName" 
                        :value="item.paraValue">
                    </el-option>
                </el-select>
                <el-input clearable v-model.trim="searchForm.address" placeholder="请输入地址" style="width:150px"></el-input>
                <el-form-item>
                    <el-select v-model="searchForm.engineerName" @change="changeEnginner" :filter-method="PinyinMatch" filterable placeholder="请选择工程师" style="width:150px" clearable>
                        <el-option v-for="(item,index) in pickingEngineerList" 
                            :label="item.name" 
                            :value="item.name"
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        style="width: 150px;"
                        v-model="valueTime3"
                        type="date"
                        @change="changeDate"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="预约时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="valueTime3">
                    <el-time-select
                        placeholder="起始时间"
                        style="width: 100px"
                        v-model="startTime"
                        :picker-options="{
                            start: '9:00',
                            step: '01:00',
                            end: '22:00'
                        }">
                      </el-time-select>
                      <el-time-select
                        placeholder="结束时间"
                        style="width: 100px"
                        v-model="endTime"
                        :picker-options="{
                            start: '9:00',
                            step: '01:00',
                            end: '22:00',
                            minTime: startTime
                        }">
                      </el-time-select>
                </el-form-item>
                <el-button type="success" @click="onSubmit('searchForm')" style="width:80px;">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 100%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        width="200"
                        label="设备详情">
                        <template slot-scope="scope">
                            <span>{{scope.row.modelName}} {{scope.row.colorName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="150"
                        align="center"
                        prop="totalAp"
                        label="故障小类">
                        <template slot-scope="scope"> 
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassShortName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="预约时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.onsiteDate }} {{scope.row.onsiteTimeStart}}~{{scope.row.onsiteTimeEnd}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="80"
                        align="center"
                        sortable
                        label="区域">
                        <template slot-scope="scope">
                            {{scope.row.countyName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="地址">
                        <template slot-scope="scope">
                            {{scope.row.address}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="100"
                        label="订单类型">
                        <template slot-scope="scope">
                            {{scope.row.serviceType | sysCodeFileter('order_type')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="120"
                        align="center"                     
                        label="订单渠道">
                        <template slot-scope="scope">
                            {{ scope.row.orderIdentifier | sysCodeFileter('order_identifier') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="handleRemark"
                        label="备注">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="orderNo"                     
                        label="订单号">
                    </el-table-column>
                    <el-table-column
                        width="60"
                        align="center"
                        fixed="right"
                        label="操作" v-if="basicsAuth.send_orders">
                        <template slot-scope="scope" v-if="basicsAuth.send_orders">
                            <el-button type="primary" size="mini" style="padding:7px" @click="newModel(scope.row)">派单</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-dialog :title="textModelMenu[dialogModelStatus]" :visible.sync="dislogModel" :close-on-click-modal="false" width="700px" :modal-append-to-body="false"  @close="emptyModelDialog('modelForm')">
                <el-form ref="modelForm" :model="modelForm" label-width="95px" :label-position="labelPosition" :rules="modelFormRules" >
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="订单号">
                                <el-input clearable disabled v-model.trim="modelForm.orderNo" placeholder="请输入关联工单"></el-input>
                            </el-form-item>
                            <el-form-item label="所在区域">
                                <el-input clearable disabled v-model.trim="modelForm.countyName"></el-input>
                            </el-form-item>
                            <el-form-item label="预约时间">
                                <el-input clearable disabled v-model.trim="modelForm.time"></el-input>
                            </el-form-item>
                            <el-form-item label="颜色">
                                <el-input clearable disabled v-model.trim="modelForm.colorName"></el-input>
                            </el-form-item>
                            <el-form-item label="客服备注">
                                <el-input clearable disabled type="textarea" v-model.trim="modelForm.engineerRemark"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="所在城市">
                                <el-input clearable disabled v-model.trim="modelForm.cityName"></el-input>
                            </el-form-item>
                            <el-form-item label="地址详情">
                                <el-input clearable disabled v-model.trim="modelForm.address"></el-input>
                            </el-form-item>
                            <el-form-item label="设备详情">
                                <el-input clearable disabled v-model.trim="modelForm.modelDetail"></el-input>
                            </el-form-item>
                            <el-form-item label="故障详情" prop="faultSubclassStr">
                                <el-input clearable disabled type="textarea" v-model.trim="modelForm.faultSubclassStr"></el-input>
                            </el-form-item>
                            <el-form-item label="派单工程师" prop="engineerId">
                                <el-select :filter-method="PinyinMatch1" v-model="modelForm.engineerId" filterable placeholder="请选择派单工程师" style="width: 100%;" clearable>
                                    <el-option v-for="(item,index) in pickingPointEngineerList" 
                                        :label="item.name" 
                                        :value="item.id" 
                                        :key="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>                    
                </el-form>
                <span slot="footer" v-if="dialogModelStatus == 'create'" class="dialog-footer" style="text-align: center">
                    <el-button type="success" @click="addModelFormSubmitBtn('modelForm')">确认</el-button>
                </span>
            </el-dialog>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10,20, 50, 100,500,1000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    import PinyinMatch from 'pinyin-match'
    import { querySendOrderList,queryRegion,sendOrders,engineerList,engineerListArea } from "../../api/order";
    import { selectParameterInfoBusiness,zhselectParameterInfoBusiness } from '@/api/api'
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'unDispatchList',
        data () {
            return {
                valueTime3:"",
                startTime:"",
                endTime:"",
                pickingCityList:[],
                pickingAreaList:[
                    {
                        paraName:'浦东',
                        paraCode:'1'
                    },
                    {
                        paraName:'浦西',
                        paraCode:'2'
                    },
                ],
                orderTypeList:[],
                OrderNolList:[],
                copy:[],
                pickingEngineerList:[],
                copy1:[],
                pickingPointEngineerList:[],
                isSh:false,
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    address:'',
                    serviceType:'',
                    orderIdentifier:'',
                    adminStatusList:["03","38"],
                    city:"",                   //所在城市
                    orderNo:'',                //订单号
                    engineerName:'',           //工程师姓名
                    countyType:'',             //所在区域
                    onsiteTimeStarts:'',       //派单开始时间
                    onsiteTimeEnds:'',         //派单结束时间
                },
                returnData: [],
                dislogModel:false,
                dialogModelStatus: "",
                textModelMenu: {
                    update: "派单详情",
                    create: "新建派单"
                },
                modelForm:{
                    engineerId:'',
                },
                modelFormRules:{//validateRoleName
                    engineerId: [{ required: true, message: "请选择派单工程师", trigger: "blur" }]
                },
                basicsAuth:{
                    send_orders:false
                }
            }
        },
        mounted () {
            this.basicsAuth.send_orders= getPermission('/api/workOrder/order/send_orders');
        },
        created(){
            this.getSendOrderList();
            this.queryRegionData(2);
            this.engineerListData();
            this.getAllOrderType();
            this.getOrderNol();
        },
        methods: {
            //强制刷新
            changeEnginner(e){
                console.log(e);
                this.searchForm.engineerName = e;
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.searchForm.engineerName = val;
                    this.pickingEngineerList = result
                }else{
                    this.pickingEngineerList = this.copy;
                    this.searchForm.engineerName = "";
                }
            },
            PinyinMatch1(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy1.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.modelForm.engineerId = val;
                    this.pickingPointEngineerList = result
                }else{
                    this.pickingPointEngineerList = this.copy1;
                    this.modelForm.engineerId = "";
                }
            },
            //获取订单类型
            getAllOrderType(){
                selectParameterInfoBusiness({
                    'startRows' : 1,
                    'pageSize' : 100,
                    'paraType' :'order_type' 
                }).then(resp => {
                    if(resp.data.results){
                        this.orderTypeList = resp.data.results.list
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //查询订单渠道
            getOrderNol(){
                let param = {
                    paraType : 'order_identifier',
                    startRow:1,
                    pageSize:10000
                }
                zhselectParameterInfoBusiness(param).then(res =>{
                    if(res.data.status == '100'){
                        this.OrderNolList = res.data.results.list
                    }
                }).catch(error =>{
                    this.$Message.error(error.message);
                })
            },
            //改变日期
            changeDate(e){
                this.startTime = null;
                this.endTime = null;
            },
            //获取所在城市列表
            queryRegionData(type){
                queryRegion({level:type}).then(res => {
                    if (res.data.status==100) {
                        this.pickingCityList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选择城市
            selectCity(e){
                this.searchForm.countyType = null;
                if(e == 310100){
                    this.isSh = true
                }else{
                    this.isSh = false;
                }
            },
            //获取工程师列表
            engineerListData(){
                engineerList({}).then(res => {
                    if (res.data.status==100) {
                        this.pickingEngineerList = res.data.results;
                        this.copy = Object.assign(this.pickingEngineerList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取工程师列表
            pointEngineerListData(){
                let para = {
                    provinceId:this.modelForm.province,
                    type:'SM' 
                }
                engineerListArea(para).then(res => {
                    if (res.data.status==100) {
                        this.pickingPointEngineerList = res.data.results;
                        this.copy1 = Object.assign(this.pickingPointEngineerList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //关闭弹出框
            emptyModelDialog() {
                this.dislogModel = false;
                Object.keys(this.modelForm).forEach(key => this.modelForm[key]= '');
                this.$refs['modelForm'].resetFields();
                this.valueTime3 = "";
                this.startTime = "";
                this.endTime = "";
            },
            //确定新建派单
            addModelFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        const loading = this.$loading({
                            lock: true,
                            text: '提交中...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.5)'
                        });
                        this.submitNewModel();
                        loading.close();
                    }else {
                        console.log('验证未通过');
                        return false;
                    }
                    
                });
            },
            //新建提交
            submitNewModel(){
                sendOrders(this.modelForm).then(res => {
                    if (res.data.status==100) {
                        this.$message({
                            message: "派单成功",
                            type: "success"
                        });
                        /*关闭弹窗，重置输入框*/
                        this.emptyModelDialog();
                        /*刷新*/
                        this.getSendOrderList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //新建派单
            newModel(item) {
                item.faultSubclassStr = "";
                item.faultSubclass.forEach((item1,index) =>{
                    if(item1.faultSubclassName){
                        item.faultSubclassStr += item1.faultSubclassName
                    }
                });
                this.modelForm = Object.assign({}, item);
                this.modelForm.time = this.modelForm.onsiteDate+' '+this.modelForm.onsiteTimeStart+' ~ '+this.modelForm.onsiteTimeEnd;
                this.modelForm.modelDetail = this.modelForm.modelName+' '+this.modelForm.colorName;

                this.pointEngineerListData();
                this.dislogModel = true;
                this.dialogModelStatus = "create";
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.adminStatusList = ["03","38"];
                this.valueTime3 = "";
                this.startTime = "";
                this.endTime = "";
                this.getSendOrderList();
            },
            //获取已派单列表
            getSendOrderList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                querySendOrderList(this.searchForm).then(res => {          
                    if (res.data.status==100) {
                        res.data.results.list.forEach((item,index)=>{
                            item.countyName = item.countyName ? item.countyName : "";
                        })           
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getSendOrderList();
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getSendOrderList();
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //检索列表
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if (this.valueTime3 == "" || this.valueTime3 == null) {
                            this.searchForm.onsiteTimeStarts = ''
                            this.searchForm.onsiteTimeEnds = ''
                        }else{
                            this.searchForm.onsiteTimeStarts = (this.startTime == "" || this.startTime == null) ? (new Date(this.valueTime3+' 00:00:00')) : (new Date(this.valueTime3+" "+this.startTime));
                            this.searchForm.onsiteTimeEnds = (this.endTime == "" || this.endTime == null) ? (new Date(this.valueTime3+' 23:59:59')) : (new Date(this.valueTime3+" "+this.endTime));
                        }
                        this.getSendOrderList();
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #unDispatchList{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        .el-form-item{
            margin-right:0;
            margin-bottom:15px
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-code{
            color:#409EFF
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .shiftTime{
            li{
                display:inline-block;
                margin-right:10px;
                font-size:14px;
                color:#666;
                margin-bottom:15px;
                cursor:pointer
            }
            li:nth-child(1){
                margin-right:5px;
                cursor:default
            }
            li.active{
                color:#409EFF
            }
        }
        .el-dialog__footer{
            text-align:center !important
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }

</style>



// WEBPACK FOOTER //
// unDispatchList.vue?3db03c12